import React, { FC } from 'react'

import { Txt } from 'src/components/atoms'
import { CheckboxWithTxt } from 'src/components/molecules'

import { CompassRoleEntity } from 'src/types/entities/CompassRole'

type Props = {
  compassRoles: CompassRoleEntity[]
  selectedCompassRoles: string[]
  updateCompassRoles: (compassRoles: string[]) => void
  className?: string
}

export const ProjectSearchCompassRole: FC<Props> = ({
  compassRoles,
  selectedCompassRoles,
  updateCompassRoles,
  className,
}) => {
  const handleOnClickCompassRole = (compassRole: string) => {
    if (selectedCompassRoles.includes(compassRole)) {
      updateCompassRoles(selectedCompassRoles.filter(roleName => roleName !== compassRole))
    } else {
      updateCompassRoles([...selectedCompassRoles, compassRole])
    }
  }

  return (
    <div className={className}>
      <Txt sizeType="s" className="tw-text-standardText-secondary">
        権限
      </Txt>
      <ul className="tw-mt-s-2">
        {compassRoles.map(compassRole => (
          <li key={compassRole.name} className="tw-mt-s0 first:tw-mt-0">
            <CheckboxWithTxt
              text={compassRole.displayName}
              checked={selectedCompassRoles.includes(compassRole.name)}
              onClick={() => handleOnClickCompassRole(compassRole.name)}
            />
          </li>
        ))}
      </ul>
    </div>
  )
}
